import React from 'react';

export const CookiePolicy = () => {
  return (
    <div
      style={{
        maxWidth: '960px',
        margin: '40px auto',
        padding: '40px',
        borderRadius: '16px',
        backdropFilter: 'blur(6px)',
        background:
          'linear-gradient(135deg, rgba(255,255,255,0.3), rgba(240,240,240,0.2))',
        boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
        fontFamily: 'sans-serif',
        color: '#000',
        fontSize: '16px',
        lineHeight: 1.6,
      }}
    >
      <h1 style={{ fontSize: '28px', marginBottom: '24px' }}>Sīkdatnes</h1>

      <h2 style={{ fontSize: '22px', marginTop: '24px' }}>Kas ir sīkdatne?</h2>
      <p>
        Sīkdatnes ir nelielas teksta datnes, kas tiek nosūtītas uz Jūsu datora
        atmiņu mājas lapas apmeklēšanas laikā. Katrā turpmākajā apmeklējuma
        reizē sīkdatnes tiek nosūtītas atpakaļ uz izcelsmes mājas lapu vai uz
        citu mājas lapu, kas atpazīst šo sīkdatni. Sīkdatnes darbojas kā
        konkrētas mājas lapas atmiņa, ļaujot šai lapai atcerēties Jūsu datoru
        nākamajās apmeklējuma reizēs, tai skaitā sīkdatnes var atcerēties Jūsu
        iestādījumus vai uzlabot lietotāja ērtības. Papildu informāciju varat
        iegūt mājas lapā www.aboutcookies.org
      </p>

      <h2 style={{ fontSize: '22px', marginTop: '24px' }}>
        Kā mēs sīkdatnes izmantojam?
      </h2>
      <p>
        Mēs izmantojam sīkdatnes vai līdzīgas tehnoloģijas, lai analizētu
        tendences, pārvaldītu interneta vietni, sekotu lietotāju darbībām un
        vāktu demogrāfisko informāciju. Sīkdatnes nesaglabā identificējošus
        datus un netiek nodotas trešajām personām.
      </p>

      <h2 style={{ fontSize: '22px', marginTop: '24px' }}>Google Analytics</h2>
      <p>
        Šī vietne izmanto Google Analītiku. Google instalē sīkdatnes, lai
        analizētu vietnes izmantojumu. Informācija tiek saglabāta Google
        serveros, un Google to izmanto, lai veidotu pārskatus par vietnes
        aktivitāti. IP adreses netiek saistītas ar citiem datiem. Jūs varat
        bloķēt sīkdatnes pārlūkprogrammas iestatījumos vai izmantot Google
        piedāvāto rīku:{' '}
        <a
          href="http://tools.google.com/dlpage/gaoptout"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://tools.google.com/dlpage/gaoptout
        </a>
        .
      </p>

      <h2 style={{ fontSize: '22px', marginTop: '24px' }}>
        Piekrišana sīkdatņu izmantošanai
      </h2>
      <p>
        Pirms sākat izmantot vietni, mēs pieprasām Jūsu piekrišanu sīkdatņu
        izmantošanai. Tādēļ tiek rādīts uznirstošais logs ar paziņojumu. Ja
        turpināt izmantot vietni bez piekrišanas atzīmēšanas, tā tiek uzskatīta
        par doto piekrišanu.
      </p>

      <h2 style={{ fontSize: '22px', marginTop: '24px' }}>
        Kā atteikties no sīkdatņu saņemšanas?
      </h2>
      <p>
        Lielākā daļa pārlūkprogrammu ļauj atteikties no sīkdatnēm. Iestatījumus
        varat mainīt pārlūka opciju vai preferenču sadaļā. Sīkāka informācija
        pieejama pārlūkprogrammas palīdzības sadaļā vai mājas lapās par
        sīkdatnēm.
      </p>
    </div>
  );
};
